export const sideNavStyles = {
    container: {
        backgroundColor: "transparent",
        marginBottom: "0",
        left: "0px",
        transform: "translateX(0px)",
        transition: "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, background-color 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        border: "none",
        boxShadow: "none",
        color: "rgba(0, 0, 0, 0.87)",
        overflow: "unset",
        display: "flex",
        flexDirection: "column",
        //    top: "2.5%",
        //  height: "95%",
        //boxSizing: 'border-box',
        flex: "1 0 auto",
        zIndex: 1200,
        position: "fixed",
        top: "0px",
        outline: "0px",
        backdropFilter: "saturate(200%) blur(1.875rem)",
        height: "calc(100vh - 2rem)",
        margin: "1rem",
        borderRadius: "1rem",
        padding: "0px",
        overflowY: "auto"

    },
    smallContainer: {
        transform: "translateX(0px)",
        transition: "transform 200ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        boxShadow: "rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem",
        border: "none",
        color: "rgba(0, 0, 0, 0.87)",
        overflow: "unset",
        display: "flex",
        flexDirection: "column",
        marginBottom: "0",
        flex: "1 0 auto",
        zIndex: 1200,
        position: "fixed",
        top: "0px",
        outline: "0px",
        left: "0px",
        //  backgroundColor: "rgba(255, 255, 255, 0.8)",
        backgroundColor: "transparent",
        backdropFilter: "saturate(200%) blur(1.875rem)",
        height: "calc(100vh - 2rem)",
        margin: "1rem",
        borderRadius: "1rem",
        padding: "0px",
        overflowY: "auto"
        //  width: "15.625rem",
        //    top: "2.5%",
        //  height: "95%",
        //boxSizing: 'border-box',
    },
    titleContainer: {
        display: "flex",
        paddingLeft: "6px"
    },
    title: {
        letterSpacing: "0.03333em",
        color: "rgb(52, 71, 103)",
        marginLeft: "20px",
        marginTop: "15px",
        fontWeight: "700",
        fontSize: "0.75rem",
        textTransform: "uppercase",
        lineHeight: 1.25,
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        opacity: 0.6,
        paddingBottom: "5px",
        paddingLeft: "5px"
    },
    divider: {
        flexShrink: 0,
        borderTop: "0px solid rgba(0, 0, 0, 0.12)",
        borderRight: "0px solid rgba(0, 0, 0, 0.12)",
        borderLeft: "0px solid rgba(0, 0, 0, 0.12)",
        borderBottom: "none",
        backgroundColor: "transparent",
        height: "0.0625rem",
        margin: "0.25rem 0px",
        opacity: 0.40,
        backgroundImage: "linear-gradient(to right, rgba(52, 71, 103, 0), rgba(52, 71, 103, 0.5), rgba(52, 71, 103, 0)) !important"
    },
    logo: {
        width: 75,
        marginLeft: 5
    },
    logoTitle: {
        verticalAlign: "top",
        lineHeight: 4.7,
        fontWeight: 500,
        fontSize: 16,
        overflow: "hidden",
        maxWidth: "155px",
        display: "inline-block"
    },
    iconButton: {
        padding: 0,
        marginBottom: "40px"
    },
    listItemButton: {
        marginLeft: "-4.7px",
        "&:hover": {
            background: "none"
        }
    },
    itemSelected: {
        backgroundColor: "rgb(255, 255, 255)",
        borderRadius: "0.5rem",
        boxShadow: "rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem",
    },
    itemText: {
        whiteSpace: "nowrap",
        fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 0,
        cursor: "pointer"
    },
    sidenavIconsBox: {
        width: "32px",
        height: "32px",
        boxShadow: "rgb(20 20 20 / 12%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(20 20 20 / 7%) 0rem 0.125rem 0.25rem -0.0625rem",
        transition: "margin 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: "0.5rem",
        // marginRight: "15px"
    },
    sidenavIcons: {
        //justifyContent: "center"
        justifyContent: "left",
        padding: "4px",
        minWidth: "unset"
    },
    listItemContainer: {
        display: "flex"
    },
    listItemBox: {
        marginLeft: "10px"
    },
    listItem: {
        width: "125px",
        color: "rgb(52, 71, 103)"
    },
    dotItem: {
        paddingRight: "10px"
    },
    selectedIcon: {
        background: "rgb(23, 193, 232)"
    }
}